import { BuildType, getOrderedLanguagesForBuildType } from '../enums/build/build-type';
import type { Language } from '../enums/language';
import { isDefaultLanguageForClub } from '../helpers/language-helper';

import { getClubInformation } from './club-look-ups-by-id';
import { getDataFolderOverrideForSiteId } from './data-folder-overrides';

export const DEFAULT_CLUB_ID = '2'; // Raynes Park

export const DEFAULT_CLUB_NAME = 'Raynes Park';

export const DEFAULT_BUILD_TYPE = BuildType.DAVID_LLOYD_UK;

const PLACEHOLDER_FOLDER = 'placeholder';

const dataRepositoryKey = (clubId: string | null, language: Language) => {
  if (clubId === null || clubId === undefined) {
    return PLACEHOLDER_FOLDER;
  }

  const clubInformation = getClubInformation(clubId);
  // TODO POD6DJ-3299 - Revert temporary override for new Hamburg Alstertal: strip the two
  //  `getDataFolderOverrideForSiteId(clubId) ??` prefixes below and remove the import.
  return clubInformation
    ? isDefaultLanguageForClub(clubId, language)
      ? (getDataFolderOverrideForSiteId(clubId) ?? clubInformation.hyphenatedClubName)
      : `${getDataFolderOverrideForSiteId(clubId) ?? clubInformation.hyphenatedClubName}_${language}`
    : PLACEHOLDER_FOLDER;
};

export const clubDataRepository = (clubId: string | null | undefined, language: Language) =>
  `${dataRepositoryKey(clubId ?? null, language)}/club`;

export const getGlobalDataFolderBase = (buildType: BuildType, language?: Language) => {
  const isDefaultLanguage =
    !language || getOrderedLanguagesForBuildType(buildType).default === language;
  return isDefaultLanguage ? `${buildType}-global` : `${buildType}-global_${language}`;
};

export const getGlobalDataFolder = (folder: string, buildType: BuildType, language?: Language) =>
  `${getGlobalDataFolderBase(buildType, language)}/${folder}`;

export const globalDataRepository = (language: Language, buildType: BuildType) => {
  return getGlobalDataFolder('global', buildType, language);
};

export const cityPageDataRepository = (language: Language | undefined, buildType: BuildType) =>
  getGlobalDataFolder('global-city-page', buildType, language);

export const helpCentreCategoryRepository = (language: Language, buildType: BuildType) =>
  getGlobalDataFolder('global-help-centre-category', buildType, language);

export const pressReleaseRepository = (language: Language, buildType: BuildType) =>
  getGlobalDataFolder('global-press-centre-page', buildType, language);
